import clsx from "clsx"
import styles from "../HowToWork.module.scss"
import { ZIC_OILS } from "../components/OilList"
import { CHECK_STATUSES, ORDER_STATUSES } from "../components/StatusTable"

export const sellerConfig = {
    greeting: "Здравствуйте, участник ZIC PROFI!",
    title: "Короткая инструкция по вашему личному кабинету",

    toc: [
        { id: "s-01", title: "Авторизация" },
        { id: "s-02", title: "Основной раздел" },
        { id: "s-03", title: "Загрузка чеков и заказ-нарядов" },
        { id: "s-04", title: "Баллы" },
        { id: "s-05", title: "Подарки" },
        { id: "s-06", title: "Полные правила программы" },
        { id: "s-07", title: "Задать вопрос" },
    ],

    sections: [
        {
            id: "s-01",
            number: "01",
            title: "Авторизация",
            body: [
                {
                    type: "p",
                    children: (
                        <>
                            Авторизуйтесь, используя электронную почту, которую вы передавали для регистрации на
                            портале. Это ваш логин. Пароль был отправлен на почту, отправитель:{" "}
                            <span className={styles.borderText}>feedback@zictop.ru</span>.
                        </>
                    ),
                },
                {
                    type: "alert",
                    children: (
                        <>
                            Если пароль не пришёл или не сохранился, воспользуйтесь{" "}
                            <span className={styles.borderText}>формой восстановления пароля</span>.
                        </>
                    ),
                },
            ],
        },

        {
            id: "s-02",
            number: "02",
            title: "Основной раздел",
            body: [
                {
                    type: "p",
                    children: (
                        <>
                            <a className={clsx(styles.linkBorder, styles.textSemibold)} href="/account">
                                Основной раздел:
                            </a>{" "}
                            вы можете отредактировать номер телефона и изменить свой пароль.
                        </>
                    ),
                },
                {
                    type: "image",
                    src: "/images/how_to_work/editing-profile.png",
                    mobileSrc: "/images/how_to_work/editing-profile-mobile.png",
                    alt: "Редактирование профиля",
                    width: 975,
                },
            ],
        },

        {
            id: "s-03",
            number: "03",
            title: "Загрузка чеков и заказ-нарядов",
            body: [
                {
                    type: "alert",
                    children: (
                        <>
                            <p>
                                Вы можете загружать <span className={styles.textBold}>чеки</span> или{" "}
                                <span className={styles.textBold}>заказ-наряды</span>.
                            </p>
                            <br />
                            <p>
                                При входе система предложит вам выбрать соответствующую стартовую страницу, которая в
                                следующие разы будет открываться автоматически.
                            </p>
                        </>
                    ),
                },
                {
                    type: "image",
                    src: "/images/how_to_work/loading-checks.png",
                    mobileSrc: "/images/how_to_work/loading-checks-mobile.png",
                    alt: "Зарегистрировать чек или заказ-наряд",
                    width: 975,
                },

                {
                    type: "subtitle",
                    id: "s-3-1",
                    number: "3.1",
                    children: (
                        <>
                            Чеки можно загрузить в разделе{" "}
                            {/* <span className={clsx(styles.borderText, styles.textSemibold)}>«Зарегистрировать чек»</span> */}
                            <a className={clsx(styles.linkBorder, styles.textSemibold)} href="/account/upload">
                                «Зарегистрировать чек»
                            </a>
                            .
                        </>
                    ),
                },
                {
                    type: "image",
                    src: "/images/how_to_work/check-registration.png",
                    mobileSrc: "/images/how_to_work/check-registration-mobile.png",
                    alt: "Форма регистрации чека",
                    width: 975,
                    lazy: true,
                },
                {
                    type: "alert",
                    children: <>Требования к загрузке чеков:</>,
                },
                {
                    type: "image",
                    src: "/images/how_to_work/check-requirements.png",
                    mobileSrc: "/images/how_to_work/check-requirements-mobile.png",
                    alt: "Зарегистрировать чек",
                    width: 670,
                    lazy: true,
                },
                {
                    type: "p",
                    children: <>Чеки проверяются в среднем в течение 3 рабочих дней.</>,
                },
                {
                    type: "oils",
                    items: ZIC_OILS,
                },
                {
                    type: "alert",
                    children: (
                        <>
                            В акции участвуют чеки с продажами не ранее 16.12.2025, которые ранее не были загружены на
                            сайт. Дубли будут исключены из акции.
                        </>
                    ),
                },
                {
                    type: "p",
                    children: (
                        <>
                            Статус проверки чеков можно посмотреть в разделе{" "}
                            <a className={clsx(styles.linkBorder, styles.textSemibold)} href="/account/receipts">
                                «Мои чеки»
                            </a>
                            .
                        </>
                    ),
                },
                {
                    type: "image",
                    src: "/images/how_to_work/my-checks.png",
                    mobileSrc: "/images/how_to_work/my-checks-mobile.png",
                    alt: "Мои чеки",
                    width: 975,
                    lazy: true,
                },
                {
                    type: "p",
                    className: styles.textSemibold,
                    children: <>Чек может иметь несколько статусов:</>,
                },
                {
                    type: "table",
                    rows: CHECK_STATUSES,
                },

                {
                    type: "subtitle",
                    id: "s-3-2",
                    number: "3.2",
                    children: (
                        <>
                            Заказ-наряды можно загрузить в разделе{" "}
                            <a className={clsx(styles.linkBorder, styles.textSemibold)} href="/account/order-upload">
                                «Зарегистрировать заказ-наряд»
                            </a>{" "}
                            нажав на кнопку «Загрузить заказ-наряд».
                        </>
                    ),
                },
                {
                    type: "image",
                    src: "/images/how_to_work/registration-order.png",
                    mobileSrc: "/images/how_to_work/registration-order-mobile.png",
                    alt: "Зарегистрировать заказ-наряд",
                    width: 975,
                    lazy: true,
                },
                {
                    type: "alert",
                    children: <>Требования к загрузке заказ-нарядов:</>,
                },
                {
                    type: "image",
                    src: "/images/how_to_work/check-requirements-order.png",
                    mobileSrc: "/images/how_to_work/check-requirements-order-mobile.png",
                    alt: "Зарегистрировать заказ-наряд, требования",
                    width: 670,
                    lazy: true,
                },
                {
                    type: "oils",
                    items: ZIC_OILS,
                },
                {
                    type: "alert",
                    children: (
                        <>
                            В акции участвуют заказ-наряды с продажами не ранее 01.04.2026, которые ранее не были
                            загружены на сайт. Дубли будут исключены из акции.
                        </>
                    ),
                },
                {
                    type: "p",
                    className: styles.textSemibold,
                    children: <>После того как вы загрузили наряд-заказ:</>,
                },
                {
                    type: "p",
                    children: <>Сначала документ проверяет ваш Дистрибьютор:</>,
                },
                {
                    type: "list",
                    items: ["корректен ли заказ,", "участвует ли масло в акции,", "верно ли указаны тара и объем."],
                },
                {
                    type: "p",
                    children: (
                        <>
                            После одобрения Дистрибьютором заказ-наряд отправляется на финальное утверждение Операторами
                            программы.
                        </>
                    ),
                },
                {
                    type: "p",
                    className: styles.textSemibold,
                    children: <>Какие могут быть статусы:</>,
                },
                {
                    type: "table",
                    rows: ORDER_STATUSES,
                },
                {
                    type: "p",
                    children: (
                        <>
                            Статус проверки заказ-нарядов можно посмотреть в разделе{" "}
                            <a className={clsx(styles.linkBorder, styles.textSemibold)} href="/account/orders-list">
                                «Мои заказ-наряды»
                            </a>
                            .
                        </>
                    ),
                },
                {
                    type: "image",
                    src: "/images/how_to_work/my-custom-orders.png",
                    mobileSrc: "/images/how_to_work/my-custom-orders-mobile.png",
                    alt: "Мои заказ-наряды",
                    width: 975,
                    lazy: true,
                },
            ],
        },

        {
            id: "s-04",
            number: "04",
            title: "Баллы",
            body: [
                {
                    type: "p",
                    children: (
                        <>
                            Загружайте чеки / заказ-наряды и получайте баллы. Количество баллов можно посмотреть в
                            боковом меню в строке «Счёт»:
                        </>
                    ),
                },
                {
                    type: "image",
                    src: "/images/how_to_work/points.png",
                    mobileSrc: "/images/how_to_work/points-mobile.png",
                    alt: "Баллы",
                    width: 338,
                    lazy: true,
                },
            ],
        },

        {
            id: "s-05",
            number: "05",
            title: "Подарки",
            body: [
                {
                    type: "p",
                    children: (
                        <>
                            Выбрать и заказать подарки можно в разделе{" "}
                            <a className={clsx(styles.linkBorder, styles.textSemibold)} href="/shop">
                                «Витрина подарков»
                            </a>
                            . Выберите подарок и нажмите «Заказать».
                        </>
                    ),
                },
                {
                    type: "alert",
                    children: <>Если баллов недостаточно, заказать подарок не получится.</>,
                },
                {
                    type: "alert",
                    children: (
                        <>
                            Если общая сумма подарков с начала участия в программе превысит 4 000 баллов, мы попросим
                            вас предоставить информацию для НДФЛ. Вкладка для подтверждения документов появится в вашем
                            Личном кабинете. Пожалуйста, заполните форму.
                        </>
                    ),
                },
                {
                    type: "image",
                    src: "/images/how_to_work/present.png",
                    mobileSrc: "/images/how_to_work/present-mobile.png",
                    alt: "Витрина подарков",
                    width: 975,
                    lazy: true,
                },
                {
                    type: "p",
                    children: <>После проверки документов подарок будет доступен.</>,
                },
                {
                    type: "p",
                    children: (
                        <>
                            Посмотреть статус по подаркам можно в разделе{" "}
                            <a className={clsx(styles.linkBorder, styles.textSemibold)} href="/account/gifts">
                                «Мои подарки»
                            </a>
                            .
                        </>
                    ),
                },
                {
                    type: "image",
                    src: "/images/how_to_work/my-present.png",
                    mobileSrc: "/images/how_to_work/my-present-mobile.png",
                    alt: "Мои подарки",
                    width: 975,
                    lazy: true,
                },
            ],
        },

        {
            id: "s-06",
            number: "06",
            title: {
                before: "Полные",
                link: { label: "правила", dynamicRules: true },
                after: "программы",
            },
        },

        {
            id: "s-07",
            number: "07",
            title: {
                before: "Вопросы можно задать через форму обратной связи",
                link: { label: "https://zictop.ru/feedback", href: "/feedback" },
                after: ".",
            },
        },
    ],
}
